"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Properties;

var _Properties = require("@adobe/react-spectrum-workflow/dist/Properties");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Properties(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Properties.A4uProperties, null));
}